import { FC, ReactNode } from 'react';
import { RouteProps } from 'react-router-dom';
import PrivateLayout from 'packages/main/components/Layouts/PrivateLayout';
import { SecureSentryRoute } from 'packages/main/routes/components/sentry-route';
import PrivateLayoutExternal from 'packages/main/components/Layouts/PrivateLayoutExternal';

export const PrivateRoute: FC<React.PropsWithChildren<RouteProps>> = ({
  component: Component,
  children,
  ...rest
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderRoute = (props: any): ReactNode => {
    return (
      <PrivateLayout>
        {Component ? <Component {...props} /> : children}
      </PrivateLayout>
    );
  };

  return <SecureSentryRoute {...rest} render={renderRoute} />;
};

export const ContractorRoute: FC<React.PropsWithChildren<RouteProps>> = ({
  component: Component,
  children,
  ...rest
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderRoute = (props: any): ReactNode => {
    return (
      <PrivateLayoutExternal>
        {Component ? <Component {...props} /> : children}
      </PrivateLayoutExternal>
    );
  };

  return <SecureSentryRoute {...rest} render={renderRoute} />;
};
